import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import global_fa from "./translations/fa/global.json";
import global_en from "./translations/en/global.json";
import i18next from "i18next";
import { I18nextProvider } from "react-i18next";
import { ThemeContextProvider } from "./context/ThemeContext";
i18next.init({
	interpolation: { escapeValue: false },
	lng: document.querySelector("html").lang,
	resources: {
		fa: {
			global: global_fa,
		},
		en: {
			global: global_en,
		},
	},
});
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	// <React.StrictMode>
	<I18nextProvider i18n={i18next}>
		<ThemeContextProvider>
			<App />
		</ThemeContextProvider>
	</I18nextProvider>,
	// </React.StrictMode>,
);
